var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInStock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 30C0 13.4315 13.4315 0 30 0C46.5685 0 60 13.4315 60 30C60 46.5685 46.5685 60 30 60C13.4315 60 0 46.5685 0 30Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.04242 31.5933C9.04242 30.8533 8.62218 30.2869 7.91872 30.0585C8.24761 29.7753 8.42119 29.3916 8.42119 28.9257C8.42119 27.9938 7.69947 27.3178 6.61231 27.3178H4.50195V33.3474H7.08737C8.26588 33.3474 9.04242 32.6074 9.04242 31.5933ZM6.52095 28.1674C7.11478 28.1674 7.4528 28.4689 7.4528 28.9713C7.4528 29.4738 7.11478 29.7936 6.52095 29.7936H5.45207V28.1674H6.52095ZM8.0649 31.5659C8.0649 32.1415 7.67206 32.4977 7.00515 32.4977H5.45207V30.6249H7.00515C7.67206 30.6249 8.0649 30.9903 8.0649 31.5659Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7099 33.3474H13.6782V30.5884H16.7113V33.3474H17.6797V27.3178H16.7113V29.7205H13.6782V27.3178H12.7099V33.3474Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2519 33.3474H24.2934L21.6349 27.2173H21.306L18.6475 33.3474H19.6799L20.1092 32.3424H22.8226L23.2519 33.3474ZM22.4754 31.5111H20.4564L21.4705 29.017L22.4754 31.5111Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9206 27.3178L25.9114 28.3044C25.8566 31.1365 25.5826 32.5343 24.7512 32.5343C24.605 32.5343 24.5228 32.5252 24.4954 32.516V33.3474C24.605 33.3931 24.7512 33.4205 24.9339 33.4205C26.2312 33.3839 26.7154 32.2145 26.8433 28.1857H28.8897V33.3474H29.8581V27.3178H25.9206Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0788 27.2173L32.3423 31.5202V27.3178H31.3739V33.4479H31.7119L35.4485 29.1358V33.3474H36.4168V27.2173H36.0788Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M41.412 27.3178V30.1499C41.074 30.3052 40.6629 30.3783 40.1696 30.3783C39.1464 30.3783 38.6348 29.8941 38.6348 28.8343V27.3178H37.6664V28.9165C37.6664 30.4605 38.5525 31.2553 40.0599 31.2553C40.5715 31.2553 41.0192 31.1731 41.412 31.0178V33.3474H42.3804V27.3178H41.412Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M48.6048 27.2173L44.8683 31.5202V27.3178H43.8999V33.4479H44.2379L47.9744 29.1358V33.3474H48.9428V27.2173H48.6048Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M55.1622 27.2173L51.4257 31.5202V27.3178H50.4573V33.4479H50.7953L54.5318 29.1358V33.3474H55.5002V27.2173H55.1622Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInStock);
export default __webpack_public_path__ + "static/media/in-stock.d4a446f28fd6d7498daea9e82f82e3aa.svg";
export { ForwardRef as ReactComponent };